import { render } from "./quoteOrder.vue?vue&type=template&id=637ec642"
import script from "./quoteOrder.vue?vue&type=script&lang=js"
export * from "./quoteOrder.vue?vue&type=script&lang=js"

import "./quoteOrder.vue?vue&type=style&index=0&id=637ec642&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__